module.exports = __webpack_public_path__ + "img/hr-red-pita-10.79ca22cf.png";